import { render } from "./ResultMessage.vue?vue&type=template&id=93096b4a"
import script from "./ResultMessage.vue?vue&type=script&lang=js"
export * from "./ResultMessage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__